import { render } from "./Badge.vue?vue&type=template&id=75c62d28&scoped=true"
import script from "./Badge.vue?vue&type=script&setup=true&lang=js"
export * from "./Badge.vue?vue&type=script&setup=true&lang=js"

import "./Badge.vue?vue&type=style&index=0&id=75c62d28&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c62d28"],['__file',"src/components/products/Badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75c62d28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75c62d28', __exports__)) {
    console.log('reload')
    api.reload('75c62d28', __exports__)
  }
  
  module.hot.accept("./Badge.vue?vue&type=template&id=75c62d28&scoped=true", () => {
    console.log('re-render')
    api.rerender('75c62d28', render)
  })

}


export default __exports__